const GlobalLoadingReducer = (state = false, action) => {
    switch (action.type) {
        case "SHOW_LOADING_ICON":
            return action.payload
        default:
            return state;
    }
};

export default GlobalLoadingReducer;